import React from 'react';

import { string, bool, func, shape } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';
import Button from '../../button/Button';
import Icon from '../../icon/Icon';

import './Pagination.scss';

/**
 * @deprecated
 */
export default class Pagination extends BaseComponent {
  render() {
    const {
      disablePrev,
      disableNext,
      style,
      id,
      className,
      previousAction,
      nextAction
    } = this.props;

    const classNames = ClassNames(className, 'Pagination-button');

    const prevButtonClass = ClassNames(classNames, 'prev-button');

    return (
      <>
        <Button
          disabled={disablePrev}
          id={id}
          style={style}
          className={prevButtonClass}
          onClick={previousAction}
          type="secondary"
        >
          <Icon icon="angleLeft" />
        </Button>
        <Button
          disabled={disableNext}
          id={id}
          style={style}
          className={classNames}
          onClick={nextAction}
          type="secondary"
        >
          <Icon icon="angleRight" />
        </Button>
      </>
    );
  }
}

Pagination.propTypes = {
  disablePrev: bool,
  disableNext: bool,
  style: shape({}),
  id: string,
  className: string,
  previousAction: func,
  nextAction: func
};

Pagination.defaultProps = {
  disablePrev: false,
  disableNext: false,
  style: {},
  id: undefined,
  className: ''
};
